import { Link } from 'react-router-dom';

import { DEFAULT_PATH } from '../routes/surfaces';

/**
 * Unrecognised route. Says "no such surface", not "not authorised" — the SPA
 * cannot tell the difference and must not imply it can. A URL the user is not
 * permitted to act on still resolves here and still loads; the API is what
 * refuses (NFR-06).
 */
export function NotFound() {
  return (
    <>
      <div className="hd">
        <div>
          <h2>No such surface</h2>
          <p>That address does not match any of the ten CLM surfaces.</p>
        </div>
      </div>
      <div className="stub">
        <span className="eyebrow">Nothing here</span>
        <p>
          If you followed a link from a notification or a Teams message, the surface may have been
          renamed. Pick a surface from the rail, or go back to the landing surface.
        </p>
        <Link className="btn sm" to={DEFAULT_PATH}>
          Needs attention
        </Link>
      </div>
    </>
  );
}
